import React from 'react';
import './LoadingSpinner.css'; // Import custom CSS for the spinner

const LoadingSpinner = () => {
  return (
    <div className="stick-ball-loader-container">
    <div className="stick-ball-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <p>Loading, please wait...</p> 
  </div>
  );
};

export default LoadingSpinner;
